module.exports = "<app-navigator id=\"appnavigator\"></app-navigator>"